import { getVietnamDateKey } from "@/lib/topup-promo";

/** Không khí Ngày Phụ nữ Việt Nam 20/10 — trùng tháng điểm danh 10/2026. */
export const WOMENS_DAY_SEASON_START = "2026-10-01";
export const WOMENS_DAY_SEASON_END = "2026-10-31";
export const WOMENS_DAY_LABEL = "Ngày Phụ nữ Việt Nam 20/10";

export function isWomensDaySeason(date: Date = new Date()): boolean {
  const key = getVietnamDateKey(date);
  return key >= WOMENS_DAY_SEASON_START && key <= WOMENS_DAY_SEASON_END;
}
